import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {MsalService} from "@azure/msal-angular";
import {AuthService} from "@services";
import {Rol} from "@enums";

@Injectable({
  providedIn: 'root'
})
export class ValidatorGuard implements CanActivate {

  constructor(private msalAuthService: MsalService,
              private authService: AuthService,
              private route: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userLogged = this.authService.getLoggedUser();
    if(userLogged.roles[0].rol == Rol.Validator) {
      return true;
    } else {
      this.route.navigateByUrl('/');
      return false;
    }
  }

}
